import React, { useState, useEffect } from "react";
import {
  Modal,
  Table,
  Button,
  Input,
  Select,
  message,
  Radio,
  InputNumber,
  AutoComplete,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  ArrowLeftOutlined,
  SettingOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { getFuelMetaData } from "../../../features/Voyage/VoyageSlice";
import { FuelList } from "../../../assets/Constants/fuelList";
import BioFuelCompositionListModal from './BioFuelCompositionListModal';
import { clearBiofuelSession } from "../../../utils/biofuelSession";
 
 
 
 
const { Option } = Select;
 
const FuelEditModal = ({ visible, setIsModalVisible, fuelShowData, setFuelShowData, setFuelData, fueldataVisible }) => {
  const safeSetFuelShowData = typeof setFuelShowData === "function" ? setFuelShowData : () => {};
  const safeSetFuelData = typeof setFuelData === "function" ? setFuelData : () => {};
  const dispatch = useDispatch();
  const { fuelMetaData } = useSelector((state) => state.voyage);
  const [isTableEdited, setIsTableEdited] = useState(false);
  const [editingData, setEditingData] = useState([]);
const [bioFuelModalVisibile, setBioFuelModalVisibile] = useState(false);
const [bioFuelDataByID, setBioFuelDataById] = useState({});
const [ID, setId] = useState(null);
const [isIceClassCondition, setIsIceClassCondition] = useState(false);
const [iceClassDistance, setIceClassDistance] = useState(0);
 
  const safe = (v) => Array.isArray(v) ? v : [];
  const safeArr = (v) => Array.isArray(v) ? v : [];
 
 
 
  // useEffect(() => {
  //   if (fuelShowData.length === 0) {
  //     // If fuelData is empty, set editingData to []
  //     setEditingData(
  //       Array.from({ length: 4 }, (_, index) => ({
  //         id: index + 1,
  //         fuel_name: "",
  //         fuel_class: "",
  //         consumption: "",
  //         fuel_lcv: "",
  //         fuel_cslip: 0,
  //         fuel_ef_ttw_MJfuel: "",
  //         fuel_ef_ttw_gfuel: "",
  //         fuel_ef_wtt_MJfuel: "",
  //         fuel_ef_wtt_gfuel: "",
  //         fuel_rwdi: 1,
  //         ice_class_consumption: 0,
  //       }))
  //     );
  //   } else {
  //     setEditingData(fuelShowData);
 
 
  //   }
  // }, [fuelShowData]);
 
useEffect(() => {
  const data = safeArr(fuelShowData);
 
  if (data.length === 0) {
    setEditingData(
      Array.from({ length: 4 }, (_, index) => ({
        id: index + 1,
        fuel_name: "",
        fuel_class: "",
        consumption: "",
        blend_percentage: "",
        fuel_lcv: "",
        fuel_cslip: 0,
        fuel_ef_ttw_MJfuel: "",
        fuel_ef_ttw_gfuel: "",
        fuel_ef_wtt_MJfuel: "",
        fuel_ef_wtt_gfuel: "",
        fuel_rwdi: 1,
        ice_class_consumption: 0,
      }))
    );
  } else {
    setEditingData(
      data.map((item, index) => ({
        id: item.id || index + 1,
        blend_percentage: item.blend_percentage ?? "",
        ...item,
      }))
    );
  }
}, [fuelShowData]);
 
  // Handle ice class condition change
  const handleIceClassConditionChange = (e) => {
    const isYes = e.target.value === "Yes";
    setIsIceClassCondition(isYes);
    setIceClassDistance(isYes ? iceClassDistance : 0); // Reset distance if 'No' is selected
    // Set ice_class_consumption to 0 for all records if 'No' is selected
    if (!isYes) {
      setEditingData((prevData) =>
        prevData.map((item) => ({ ...item, ice_class_consumption: 0 }))
      );
    }
  };
 
  const handleIceClassDistanceChange = (value) => {
    setIceClassDistance(value);
  };
 
  // Remove row function
  const handleRemoveRow = (id) => {
    setEditingData((prevData) => prevData.filter((row) => row.id !== id));
  };
 
  const addNewFuelRow = () => {
    // Add a new row with default empty values
    setEditingData((prevData) => {
      const nextId = prevData.reduce(
        (max, row) => Math.max(max, row.id || 0),
        0
      ) + 1;
 
      return [
        ...prevData,
        {
          id: nextId,
          fuel_name: "",
          fuel_class: "",
          consumption: "",
          blend_percentage: "",
          fuel_lcv: "",
          fuel_cslip: 0,
          fuel_ef_ttw_MJfuel: "",
          fuel_ef_ttw_gfuel: "",
          fuel_ef_wtt_MJfuel: "",
          fuel_ef_wtt_gfuel: "",
          fuel_rwdi: 1,
          ice_class_consumption: 0,
        },
      ];
    });
  };
 
  const createPayload = (data) => {
    const fuelfactorData = data.map((item) => ({
      fuel_name: item.fuel_name || "N/A",
      fuel_class: item.fuel_class || "N/A",
      consumption: item.consumption ? parseFloat(item.consumption) : 0,
      ice_class_consumption: item.ice_class_consumption || 0,
      blend_percentage: item.blend_percentage
        ? parseFloat(item.blend_percentage)
        : 0,
 
      fuel_factor:
        item.fuel_class === "Biofuel" && bioFuelDataByID[item.id]
          ? bioFuelDataByID[item.id]?.fuel_factor // Use BioFuelDataById data if class is Biofuel and data exists
          : [
            {
              ef_wtt_MJfuel: item.fuel_ef_wtt_MJfuel
                ? parseFloat(item.fuel_ef_wtt_MJfuel)
                : 0,
              ef_wtt_gfuel: item.fuel_ef_wtt_gfuel
                ? parseFloat(item.fuel_ef_wtt_gfuel)
                : 0,
              ef_ttw_MJfuel: item.fuel_ef_ttw_MJfuel
                ? parseFloat(item.fuel_ef_ttw_MJfuel)
                : 0,
              lcv: item.fuel_lcv ? parseFloat(item.fuel_lcv) : 0,
              cslip: item.fuel_cslip ? parseFloat(item.fuel_cslip) : 0,
              rwdi: item.fuel_rwdi ? parseFloat(item.fuel_rwdi) : 0,
              ef_ttw_gfuel: item.fuel_ef_ttw_gfuel
                ? parseFloat(item.fuel_ef_ttw_gfuel)
                : 0,
            },
          ],
    }));
 
    return {
      data: fuelfactorData,
      ice_class_distance: iceClassDistance || 0,
      is_ice_class: isIceClassCondition,
    };
  };
 
  const handleFuelsAddition = async () => {
    const emptyRows = editingData.filter(
      (row) =>
        !row.fuel_name &&
        !row.fuel_class &&
        !row.consumption &&
        !row.fuel_lcv &&
        !row.fuel_ef_ttw_MJfuel &&
        !row.fuel_ef_ttw_gfuel &&
        !row.fuel_ef_wtt_MJfuel &&
        !row.fuel_ef_wtt_gfuel
    );
 
    if (emptyRows.length < 0) {
      message.error("Please remove empty rows before proceeding.");
      return;
    } else {
      // Validation specific to Biofuel class
      const biofuelErrors = editingData.filter(
        (row) =>
          row.fuel_class === "Biofuel" && (!row.fuel_name || !row.consumption)
      );
 
      if (biofuelErrors.length < 0) {
        message.error("Name and consumption are required for Biofuel.");
        return;
      } else {
        const requiredKeys = [
          "fuel_name",
         
          "consumption",
          "fuel_lcv",
         
         
          "fuel_rwdi",
        ];
 
        // Validation for any empty fields
        const hasEmptyFields = editingData.some(
          (row) =>
            row.fuel_class !== "Biofuel" &&
            requiredKeys.some((key) => row[key] === "" || row[key] === undefined)
        );
        if (hasEmptyFields) {
          message.error("Add all the data before submitting fuels.");
          return;
        } else {
          const missingBiofuelData = editingData.some(
            (row) =>
              row.fuel_class === "Biofuel" &&
              (!bioFuelDataByID[row.id] ||
                Object.values(bioFuelDataByID[row.id]).every(
                  (value) => value === ""
                ))
          );
 
          if (missingBiofuelData) {
            message.error("Add Biofuel Data before proceeding.");
            return;
          }
          safeSetFuelShowData(editingData);
          safeSetFuelData(createPayload(editingData));
          handleClose();
        }
      }
    }
  };
 
  const handleInputChange = (e, record, key) => {
 
    const newValue =
      key === "fuel_name" || key === "fuel_class"
        ? e.target.value
        : !isNaN(e.target.value) || e.target.value === "."
          ? e.target.value
          : null;
 
    const newData = [...editingData];
    const index = editingData.findIndex((item) => record.id === item.id);
 
    const item = newData[index];
    newData[index] = {
      ...item,
      [key]: newValue,
      modified: {
        ...item.modified,
        [key]: item[key] !== newValue,
      },
    };
    setEditingData(newData);
  };
 
  const handleSelectChange = async (value, record, key, passType) => {
    const newData = [...editingData];
    const index = newData.findIndex((item) => record.id === item.id);
    const item = newData[index];
 
    if (key === "fuel_name" && passType === "type") {
      newData[index] = {
        ...item,
        [key]: value,
        modified: {
          ...item.modified,
          [key]: item[key] !== value,
        },
 
      };
 
      setEditingData(newData);
      return;
 
    }
 
    if (key === "fuel_class") {
      newData[index] = {
        ...item,
        [key]: value,
        modified: {
          ...item.modified,
          [key]: item[key] !== value,
        },
      };
 
      setEditingData(newData);
      return;
    }
 
    let metaData = {};
    try {
      const response = await dispatch(getFuelMetaData(value));
      metaData = response.payload;
    } catch (error) {
      console.error("Error fetching metadata:", error);
    }
 
    newData[index] = {
      ...item,
      [key]: value,
      isFuelClassLocked: true,
      modified: {
        ...item.modified,
        [key]: item[key] !== value,
      },
    };
 
 
    if (Object.keys(metaData).length > 0) {
      Object.keys(metaData).forEach((fuelDetail) => {
        const val = {
          target: {
            value: metaData[fuelDetail],
          },
        };
 
 
        newData[index] = {
          ...newData[index],
          [fuelDetail]: metaData[fuelDetail],
          modified: {
            ...newData[index].modified,
            [fuelDetail]: newData[index][fuelDetail] !== metaData[fuelDetail],
          },
        };
      });
    }
 
 
    setEditingData(newData);
  };
 
 
  const handleClose = () => {
    // setEditingData([]);
    // setIsTableEdited(false);
    setIsModalVisible(false);
  };
 
  const formatNumber = (value) => {
    if (typeof value === "number") {
      return value.toFixed(
        Math.min(6, (value.toString().split(".")[1] || "").length)
      );
    }
    return value;
  };
const handleBiofuelCompositionSubmit = ({ composition }) => {
  if (!Array.isArray(composition) || !composition.length) {
    message.warning("Add a biofuel composition before submitting.");
    return;
  }
 
  const source = composition[1];
 
  setEditingData((prevData) =>
    prevData.map((row, index) => {
      if (index !== 1) return row;
 
      return {
        ...row,
        fuel_name: source.blend_name || row.fuel_name,
        fuel_class: "",
        consumption:
          source.blend_ratio ?? source.blend_percentage ?? row.consumption,
        fuel_lcv: source.lcv ?? row.fuel_lcv,
        fuel_rwdi: source.rwdi ?? row.fuel_rwdi,
        ice_class_consumption: isIceClassCondition
          ? iceClassDistance || 0
          : 0,
      };
    })
  );
 
  setBioFuelDataById((prev) => {
    const secondRowId = editingData?.[1]?.id;
 
    if (!secondRowId) return prev;
 
    return {
      ...prev,
      [secondRowId]: {
        fuel_factor: [
          {
            lcv: source.lcv ?? 0,
            rwdi: source.rwdi ?? 0,
            fuel_name_1: source.blend_name || "",
            blend_percentage:
              parseFloat(
                source.blend_ratio ?? source.blend_percentage ?? 0
              ) || 0,
          },
        ],
      },
    };
  });
 
  setBioFuelModalVisibile(false);
  message.success("Fuel data added.");
};
 
 
 
  const columns = [
    {
      title: "Fuel name",
      dataIndex: "fuel_name",
      key: "fuel_name",
      width: 150,
      fixed: "left",
      render: (text, record) => {
        const isDisabled = fueldataVisible || record?.fuel_class === "Biofuel";
        return (
          <AutoComplete
            value={text}
            className={
              record.modified?.fuel_name
                ? "fuel-class-custom-select fuel-name-custom-select modified-cell"
                : "fuel-class-custom-select fuel-name-custom-select"
            }
            disabled={isDisabled}
            options={FuelList.map((fuel) => ({
              value: fuel.fuel_name,
            }))}
            onSelect={(value) => handleSelectChange(value, record, "fuel_name", "select")}
            onChange={(value) => handleSelectChange(value, record, "fuel_name", "type")}
            filterOption={(inputValue, option) =>
              option.value.toLowerCase().includes(inputValue.toLowerCase())
            }
            getPopupContainer={() => document.body}
            dropdownStyle={{ zIndex: 9999 }}
            allowClear
          />
        );
      },
    },
    {
      title: "Fuel Class",
      dataIndex: "fuel_class",
      key: "fuel_class",
      width: 100,
      render: (text, record) => {
        return (
          <Select
            className={
              record.modified?.fuel_class
                ? "fuel-class-custom-select modified-cell"
                : "fuel-class-custom-select"
            }
            disabled={fueldataVisible || record.isFuelClassLocked}
            value={text}
            onChange={(value) =>
              handleSelectChange(value, record, "fuel_class")
            }
          >
            <Option value="Fossil">Fossil</Option>
            <Option value="RFNBO">RFNBO</Option>
            <Option value="Biofuel">Biofuel</Option>
          </Select>
        );
      },
    },
    {
      title: "Blend Percentage",
      dataIndex: "blend_percentage",
      key: "blend_percentage",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={fueldataVisible}
          className={record.modified?.blend_percentage ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "blend_percentage")}
        />
      ),
    },
    {
      title: "Consumption(MT)",
      dataIndex: "consumption",
      key: "consumption",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={fueldataVisible}
          className={record.modified?.consumption ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "consumption")}
        />
      ),
    },
    {
      title: "LCV(MJ/MT)",
      dataIndex: "fuel_lcv",
      key: "fuel_lcv",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={record?.fuel_class === "Biofuel" || fueldataVisible}
          className={record.modified?.fuel_lcv ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "fuel_lcv")}
        />
      ),
    },
    {
      title: "Cslip",
      dataIndex: "fuel_cslip",
      key: "fuel_cslip",
      width: 150,
      render: (text, record) => (
        <Input
          className={record.modified?.fuel_cslip ? "modified-cell" : ""}
          value={formatNumber(text)}
          disabled={fueldataVisible}
          onChange={(e) => handleInputChange(e, record, "fuel_cslip")}
        />
      ),
    },
    {
      title: "EF-TTW (MJfuel)",
      dataIndex: "fuel_ef_ttw_MJfuel",
      key: "fuel_ef_ttw_MJfuel",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={record?.fuel_class === "Biofuel" || fueldataVisible}
          className={record.modified?.fuel_ef_ttw_MJfuel ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "fuel_ef_ttw_MJfuel")}
        />
      ),
    },
    {
      title: "EF-TTW (Gfuel)",
      dataIndex: "fuel_ef_ttw_gfuel",
      key: "fuel_ef_ttw_gfuel",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={record?.fuel_class === "Biofuel" || fueldataVisible}
          className={record.modified?.fuel_ef_ttw_gfuel ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "fuel_ef_ttw_gfuel")}
        />
      ),
    },
    {
      title: "EF-WTT (MJfuel)",
      dataIndex: "fuel_ef_wtt_MJfuel",
      key: "fuel_ef_wtt_MJfuel",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={record?.fuel_class === "Biofuel" || fueldataVisible}
          className={record.modified?.fuel_ef_wtt_MJfuel ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "fuel_ef_wtt_MJfuel")}
        />
      ),
    },
    {
      title: "EF-WTT (Gfuel)",
      dataIndex: "fuel_ef_wtt_gfuel",
      key: "fuel_ef_wtt_gfuel",
      width: 150,
      render: (text, record) => (
        <Input
          disabled={record?.fuel_class === "Biofuel" || fueldataVisible}
          className={record.modified?.fuel_ef_wtt_gfuel ? "modified-cell" : ""}
          value={formatNumber(text)}
          onChange={(e) => handleInputChange(e, record, "fuel_ef_wtt_gfuel")}
        />
      ),
    },
    {
      title: "RWDi",
      dataIndex: "fuel_rwdi",
      key: "fuel_rwdi",
      width: 50,
      render: (text, record) => (
        <Input
          className={record.modified?.fuel_rwdi ? "modified-cell" : ""}
          value={formatNumber(text)}
          disabled={fueldataVisible}
          onChange={(e) => handleInputChange(e, record, "fuel_rwdi")}
        />
      ),
    },
    ...(isIceClassCondition
      ? [
        {
          title: "Ice Class Consumption",
          dataIndex: "ice_class_consumption",
          key: "ice_class_consumption",
          width: 150,
          render: (text, record) => (
            <Input
              value={text}
              disabled={fueldataVisible}
              onChange={(e) =>
                handleInputChange(e, record, "ice_class_consumption")
              }
            />
          ),
        },
      ]
      : []),
    {
      title: " Edit ",
      key: "settings",
      align: "center",
      width: 50,
      render: (text, record) => {
        return record?.fuel_class === "Biofuel" ? (
          <SettingOutlined
            onClick={() => {
              setBioFuelModalVisibile(true);
              const matchedFuel = editingData.find(fuel => fuel.id === record.id);
              setBioFuelDataById((prevState) => {
                if (prevState[record.id]) {
                  return prevState;
                }
                return {
                  ...prevState,
                  [record.id]: {
                    fuel_factor: {
                      fuel_name_1: matchedFuel?.fuel_name || "",
                    }
                  },
                };
              });
              setId(record.id);
            }}
            style={{ cursor: "pointer" }}
          />
        ) : (
          <Input value="" disabled />
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 50,
      render: (_, record) =>
        record.id > 1 && (
          fueldataVisible ? "" :
            <CloseOutlined
              onClick={() => handleRemoveRow(record.id)}
              style={{ cursor: "pointer", color: "red", marginLeft: "15px" }}
            />
        ),
    },
  ];
 
  return (
    <Modal
      title="Edit Details"
      visible={visible}
      onCancel={handleClose}
      footer={[
        <div className="fuel-edit-modal-footer">
          <div className="fuel-edit-modal-footer-remark">
            {fueldataVisible ? '' :
              <Button type="primary" onClick={addNewFuelRow}>
                Add More Fuels
              </Button>
            }
          </div>
          <div className="fuel-edit-modal-footer-buttons">
            <Button
              key="back"
              onClick={handleClose}
              icon={<ArrowLeftOutlined />}
              className="cancel-button-stepper"
            >
              Close
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={handleFuelsAddition}
              className="stepper-next-button"
            >
              Done
            </Button>
          </div>
        </div>,
      ]}
      className="fuel-edit-modal"
      style={{ top: 50 }}
    >
      <div style={{ marginBottom: 16 }}>
        <label>Is ice class condition? </label>
        <Radio.Group
          value={isIceClassCondition ? "Yes" : "No"}
          onChange={handleIceClassConditionChange}
        >
          <Radio value="Yes">Yes</Radio>
          <Radio value="No">No</Radio>
        </Radio.Group>
        {isIceClassCondition && (
          <>
            <span>Enter Ice Class Distance</span>
            <InputNumber
              placeholder="Enter Ice Class Distance"
              value={iceClassDistance}
              onChange={handleIceClassDistanceChange}
              style={{ marginLeft: 8, width: '250px' }}
            />
          </>
        )}
      </div>
 
      <Table
        dataSource={editingData}
        columns={columns}
        rowKey="id"
        pagination={false}
        // scroll={{ x: 2100 }}
        className="fuel-data-stepper-table"
        bordered
      />
 
    <BioFuelCompositionListModal
   visible={bioFuelModalVisibile}
  onClose={() => setBioFuelModalVisibile(false)}
  onSubmit={handleBiofuelCompositionSubmit}
/>
 
    </Modal>
  );
};
 
export default FuelEditModal;
 
 